import logo from './logo.svg';
import './App.css';
import React from 'react';

class AppBook extends React.Component {

  constructor(props) {
    super(props);
    this.naplnTextyPodlaJazyka();
  }
  nadpisOnlineSkoleni = "";
  nadpisPrezencnychSkoleni = "";
  eTurboRoutre = "";
  eTurboRoutreUrl = "";
  eTurboSwitche = "";
  eTurboSwitcheUrl = "";
  naplnTextyPodlaJazyka() {
    let nacitanePremium = document.getElementById("lit-cs-lang4r").innerHTML;

    
        this.urlObrazku = "/../style/cisco-kniha.png";
        this.datumDenKurzu = "23.03";
        if (String(nacitanePremium) == 'sk') {
          this.popisKurzu = 'Michalova cesta sieťového inžiniera začala kúpou tejto knižky...';
          this.urlKurzu = "/kurzy/5/elektronicka-knizka-o-smerovacoch-cisco.html";
          this.buttonNadpis = 'zistiť viac...';
        } else if (String(nacitanePremium) == 'cz') {
          this.popisKurzu = 'Michalova cesta síťového inženýra začala koupí této knížky...';
          this.urlKurzu = "/cz/elektronicka-knizka-o-smerovacoch-cisco-i37.html";
          this.buttonNadpis = 'zjistit více...';
        }
      
    
  }
  

  render() {
    return (
      <a href={this.urlKurzu}>
      <div className="lit-cmp-blog-ads-dop row rounded shadow m-3">
            <div className='row'>
              <div className='col-lg-4'>
              <a href={this.urlKurzu}>
              <img className='img-fulid m-2 rounded' id='lit-cmp-book' src={this.urlObrazku}/>
              </a>
              </div>
                <div className='col-lg-8 lit-cmp-popis'>
                  <p className='fs-2 mt-3'>{this.popisKurzu}</p>
                  <a href={this.urlKurzu} className='btn lit-cmp-cta-button mb-3 lit-cmp-cta-button-book'>{this.buttonNadpis}</a>
                </div>
              </div>
            </div>
            </a>
    );

    }
}

export default AppBook;
